export const labels = {
	addPhotoZone: {
		label: "Label.MobileCreator.BottomMenu.Photo.AddPhotoZone",
		default: "Add photo zone",
	},
	autofill: {
		label: "Label.MobileCreator.PhotoSelection.AutoFill",
		default: "Autofill",
	},
	addPhotos: {
		label: "Label.MobileCreator.PhotoSelection.AddPhotos",
		default: "Add Photos",
	},
	addPhotosLong: {
		label: "Label.MobileCreator.PhotoSelection.TapToAddMore",
		default: "Tap here to start adding your photos",
	},
};
